module.exports = __webpack_public_path__ + "img/img2@2x.663523e7.png";